<template lang="pug">
.new-bonus.center
  form(@submit.prevent="" autocomplete="off")
    h2.title Crear Nuevo Bono

    .form-section
      .input-container
        input.input(v-model="dataForm.phone" type="text" autocomplete="ño" maxlength="10" required)
        label.label.capitalize(:class="{ show: dataForm.phone }") Celular del Cliente (10 dígitos)

      .input-container.arrow
        select.select(v-model="dataForm.brand" autocomplete="ño" required)
          option(value="")
          option(v-for="brand in brands" :value="brand") {{ capitalize(brand) }}
        label.label.capitalize(:class="{ show: dataForm.brand }") Marca

      .input-container
        textarea.input(v-model="dataForm.reason" autocomplete="ño" rows="3" required)
        label.label.capitalize(:class="{ show: dataForm.reason }") Motivo del Bono

      .input-container
        input.input(v-model.number="dataForm.originalValue" type="number" autocomplete="ño" min="1" required)
        label.label.capitalize(:class="{ show: dataForm.originalValue }") Valor del Bono

      .input-container
        input.input(v-model.number="dataForm.promotionPercent" type="number" autocomplete="ño" min="0" max="100" step="0.01")
        label.label.capitalize(:class="{ show: dataForm.promotionPercent }") % de Promoción (opcional, 0-100)

      .input-container
        textarea.input(v-model="dataForm.observation" autocomplete="ño" rows="3")
        label.label.capitalize(:class="{ show: dataForm.observation }") Observación (opcional)

    shActionButton(:isForm="true" text="Crear Bono" textRunning="Creando" :action="sendForm")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import gql from '@my/graphql'
import gqlBonus from '@/graphql/bonus'
import modals from '@my/store/modals'

export default {
  name: 'NewBonus',

  mixins: [mForm, mFilters],

  data () {
    return {
      dataForm: {
        phone: '',
        brand: '',
        reason: '',
        originalValue: null,
        promotionPercent: 0,
        observation: ''
      }
    }
  },

  methods: {
    async sendForm () {
      // Validaciones
      if (!this.dataForm.phone || this.dataForm.phone.length !== 10) {
        modals.showMessage({ message: 'El teléfono debe tener 10 dígitos', error: true })
        return
      }

      if (!this.dataForm.brand) {
        modals.showMessage({ message: 'Debes seleccionar la marca', error: true })
        return
      }

      if (!this.dataForm.reason) {
        modals.showMessage({ message: 'El motivo es requerido', error: true })
        return
      }

      if (!this.dataForm.originalValue || this.dataForm.originalValue <= 0) {
        modals.showMessage({ message: 'El valor original debe ser mayor a 0', error: true })
        return
      }

      if (this.dataForm.promotionPercent < 0 || this.dataForm.promotionPercent > 100) {
        modals.showMessage({ message: 'El porcentaje de promoción debe estar entre 0 y 100', error: true })
        return
      }

      try {
        const mutation = gqlBonus.CREATE

        const input = {
          phone: this.dataForm.phone,
          brand: this.dataForm.brand,
          reason: this.dataForm.reason,
          originalValue: this.dataForm.originalValue,
          promotionPercent: this.dataForm.promotionPercent || 0
        }

        if (this.dataForm.observation) {
          input.observation = this.dataForm.observation
        }

        const response = await gql.mutate(mutation, { input })

        console.log(response)

        if (response && response.data && response.data.createBonus) {
          modals.showMessage({ message: `Bono ${response.data.createBonus.bonus} creado correctamente` })
          this.resetForm()
          this.$router.push('/bonuses')
        }
      } catch (error) {
        console.error(error)
        modals.showMessage({ message: error.message || 'Error al crear el bono', error: true })
      }
    },

    resetForm () {
      this.dataForm = {
        phone: '',
        brand: '',
        reason: '',
        originalValue: null,
        promotionPercent: 0,
        observation: ''
      }
    }
  },

  computed: {
    brands () {
      return this.$store.state.variables.brands
    }
  }
}
</script>

<style lang="stylus">
.new-bonus
  position relative

.new-bonus .button-action
  margin-top 2em
</style>




// WEBPACK FOOTER //
// src/components/pages/bonus/New.vue